import { IconLoader, IconLogin } from '@tabler/icons-react';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AdminData, useAuthenticationHook, useGetAdminByToken } from 'src/API/rest.authentication';
import { ButtonIconSquare, ButtonRounded } from 'src/components/buttons';
import { InputOTPDemo } from 'src/components/inputotp';
import { InputStandard } from 'src/components/standard.input';
import { validationErrorToObject } from 'src/lib/utils';
import { setadminDetails } from 'src/redux/admin.slice/admin.slice';
import { ToastAction } from 'src/shadcn/ui/toast';
import { toast } from 'src/shadcn/ui/use-toast';


type formData = {
  PAT:string
}



export default function Loginpage() {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const {
    loginByPAT,
    isLoginning,
    adminTest,
  } = useAuthenticationHook()

  const {
    adminData,
    adminError,
    getAdminbyTokenRefetch,
    isgetAdminbyTokenError,
    isgetAdminbyTokenFetched,
    isgetAdminbyTokenFetching,
    isgetAdminbyTokenLoading
  } = useGetAdminByToken({
    trigger:true
  })



  const { register, handleSubmit, setValue, setError, reset, formState: { errors }, control, watch } = useForm<formData>({
    defaultValues: {
      PAT: ""
    }
  });

  const onSubmit = async (data: formData) => {

    const response = await loginByPAT(data)
    console.log(response)
    if (response.success === true) {

      dispatch(setadminDetails(response.data as AdminData))
      navigate('/home/dashboard',{replace:true})

    } else {

      
      toast({
        title: 'Error',
        description: response.msg,
      })
    }

  }

  // handle if login redirect to dashboard
  useEffect(
    () => {

      if (!isgetAdminbyTokenFetching && !adminError && adminData && !isgetAdminbyTokenLoading) {

        if (adminData.statusCode !== 401) {
          navigate('/home/dashboard',{replace:true})
        }
      }

    }, [isgetAdminbyTokenFetching]
  )

  if (isgetAdminbyTokenFetching) {
    return <div>Loading...</div>
  }


  return (
    <div className="md:p-8 bg-gray-200 h-screen relative">
      <div
        className="h-full bg-cover bg-center flex items-center justify-center rounded-md">
        <div className="">
          <div className="bg-[#ffffff69] w-[400px] h-1/2 md:h-full rounded-md p-3">

            <div className="flex items-center mt-6 h-[50%]">
              <form
                className="w-full text-center flex justify-center items-center flex-col gap-2"
                onSubmit={handleSubmit(onSubmit)}
              >
                <InputStandard
                  placeholder="Enter Personal access tocken"
                  title='PAT'
                  type="text"
                  {...register("PAT", {
                    required: "PAT is required",
                    // pattern: {
                    //   value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    //   message: "Invalid email address",
                    // },
                  })}
                  error={errors.PAT?.message}
                />
                <ButtonIconSquare
                  text='Login'
                  type='submit'
                  variant='secondary'
                  icon={isLoginning ? <IconLoader className='animate-spin' /> : <IconLogin />}
                />

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
